import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import styles from 'designer/styles/modal.module.css'
import Component from './index'

import {
  getElementAction,
  updateCondition,
} from 'designer/component/action/Condition'
import { getForm, getPage } from 'designer/component/action/Design'
import {
  compareTwoValue,
  generateString,
  getCurrentUi,
  setRequestFormData,
  updateFormDataValue,
} from '../action/Data'
import { isNumber } from '../action/Data'
import PatientAssessment from './PatientAssessment'
import cloneDeep from 'clone-deep'
import { onCheckCondition } from '../action/condition/Action'
import { checkPropTab, getApi } from '../action/Api'
import httpClient from 'utility/httpClient.util'
import { debounceCallback } from 'utility/debounceCallback.util'
import Title from '../container/title/Title'
import { onTriggerModal } from '../element/button/Modal'
import { getRowIndex } from '../element/table/action/index'

const NormalModal = ({
  children,
  isOpenModal,
  closeExternalModal,
  ui,
  modalAction,
}) => {
  const modalSize = modalAction?.modalSize || ui?.modalSize || 'xl'
  const cardColor = modalAction?.cardColor || ui.cardColor
  const textColor = modalAction?.textColor || ui.textColor
  const title = modalAction?.title || ui.title
  const closeButton = modalAction?.closeButton
  let props = {
    uischema: { ...modalAction, ...ui },
    isModalTitle: true,
    isActive: false,
    modalTitle: title,
  }
  return (
    <Modal show={isOpenModal} size={modalSize}>
      <Modal.Header
        closeButton={closeButton === undefined ? true : closeButton}
        onHide={closeExternalModal}
        style={{
          backgroundColor: cardColor || '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: textColor || '#000',
          }}
        >
          <Title {...props} />
        </h5>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  )
}

const FullSizeModal = ({
  children,
  isOpenModal,
  closeExternalModal,
  ui,
  modalAction,
}) => {
  const cardColor = modalAction?.cardColor || ui.cardColor
  const textColor = modalAction?.textColor || ui.textColor
  const title = modalAction?.title || ui.title
  const closeButton = modalAction?.closeButton
  let props = {
    uischema: { ...modalAction, ...ui },
    isModalTitle: true,
    isActive: false,
    modalTitle: title,
  }
  return (
    <Modal
      fullscreen="true"
      dialogClassName={styles.modalFullScreen}
      className="pl-0"
      show={isOpenModal}
    >
      <Modal.Header
        closeButton={closeButton === undefined ? true : closeButton}
        onHide={closeExternalModal}
        style={{
          backgroundColor: cardColor || '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: textColor || '#000',
          }}
        >
          <Title {...props} />
        </h5>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  )
}

const ModalTable = (props) => {
  const {
    state,
    setState,
    ui,
    isOpenModal,
    setIsOpenModal,
    onRefreshTable,
    designerPropsData,
    dataRowSelected,
  } = props

  const designContext = useContext(DesignContext)
  const datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const {
    jsonForm,
    openModal,
    setSchema,
    isUiChanged,
    setIsUiChanged,
    setJsonForm,
    searchData,
  } = designContext

  const modalAction = state?.altModal || props?.modalAction || {}
  const modalId = objectPath.get(modalAction, 'formId')
  const modalCode = objectPath.get(modalAction, 'formCode')
  const { modalSize = 'xl', modalType = '', sourceType = '' } = modalAction

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }

  const [modal, setModal] = useState({})
  const parentJsonFormRef = useRef(null)
  const parentFormDataRef = useRef(null)
  const parentSearchDataRef = useRef(null)

  const closeExternalModal = (componentPropsData = {}, receiveProps = []) => {
    let currentJsonForm = jsonForm
    let parentJsonForm = parentJsonFormRef.current || currentJsonForm
    let parentDesignContext = {
      ...designContext,
      jsonForm: parentJsonForm,
    }
    let formData = cloneDeep(
      parentFormDataRef.current ||
        objectPath.get(parentJsonForm, 'formData') ||
        {},
    )
    let isPage = parentDesignContext.isPage
    let newSearchData = {
      ...(parentSearchDataRef.current || searchData),
      ...formData,
    }
    let sendProps = receiveProps.filter(
      ({ propSend, propReceive }) => propSend && !propReceive,
    )
    let designerData = objectPath.get(componentPropsData, 'data')
    sendProps.forEach(({ systemType, elementKey, fullPropKey, prop }) => {
      let propKey = fullPropKey || prop
      if (systemType === 'replaceRow') {
        let rowData = objectPath.get(designerData, propKey)
        console.log('closeExternalModal rowData', rowData)
        if (!rowData) return
        let tableUi = getCurrentUi(
          elementKey,
          parentJsonForm.schema,
          parentJsonForm.uischema,
        )
        if (tableUi.key === elementKey) {
          let favoriteRow = objectPath.get(isUiChanged, [
            'favoriteRow',
            tableUi.key,
          ])
          let isFavorite = favoriteRow && Object.keys(favoriteRow).length > 0
          let isDataRowSelected =
            dataRowSelected && Object.keys(dataRowSelected).length > 0
          let favoriteTable = objectPath.get(isUiChanged, [
            'favoriteTable',
            tableUi.key,
          ])
          let columnRefId = tableUi?.loadData?.columnRefId
          let currentTable = isFavorite
            ? favoriteTable
            : objectPath.get(formData, tableUi.name) ||
              objectPath.get(formData, tableUi.key)
          if (!currentTable) return
          let currentIndex
          if (isFavorite) {
            currentIndex = currentTable.findIndex((item) => {
              if (item['@genId'] && favoriteRow['@genId']) {
                return item['@genId'] === favoriteRow['@genId']
              }
              if (columnRefId) {
                return (
                  objectPath.get(item, columnRefId) ===
                  objectPath.get(favoriteRow, columnRefId)
                )
              }
              return item?.tableData?.no === favoriteRow?.tableData?.no
            })
          } else if (isDataRowSelected) {
            currentIndex = currentTable.findIndex((item) => {
              if (item['@genId'] && dataRowSelected['@genId']) {
                return item['@genId'] === dataRowSelected['@genId']
              }
              if (columnRefId) {
                return (
                  objectPath.get(item, columnRefId) ===
                  objectPath.get(dataRowSelected, columnRefId)
                )
              }
              return item?.tableData?.no === dataRowSelected?.tableData?.no
            })
          } else {
            currentIndex = currentTable.findIndex((item) => {
              if (item['@genId'] && rowData['@genId']) {
                return item['@genId'] === rowData['@genId']
              }
              if (columnRefId) {
                return (
                  objectPath.get(item, columnRefId) ===
                  objectPath.get(rowData, columnRefId)
                )
              }
              return item?.tableData?.no === rowData?.tableData?.no
            })
          }
          if (currentIndex > -1) {
            let currentRow = currentTable[currentIndex]
            objectPath.del(rowData, '@seq')
            objectPath.del(rowData, 'tableData')
            let newRow = {}
            if (isFavorite) {
              newRow = {
                ...currentRow,
                ...favoriteRow,
              }
            } else if (isDataRowSelected) {
              newRow = {
                ...currentRow,
                ...dataRowSelected,
              }
            }
            newRow = {
              ...newRow,
              ...rowData,
            }

            const updatedTable = currentTable.map((row, index) =>
              index === currentIndex ? newRow : row,
            )
            if (isFavorite) {
              objectPath.del(isUiChanged, ['favoriteRow', tableUi.key])
              objectPath.set(
                isUiChanged,
                ['favoriteTable', tableUi.key],
                updatedTable,
              )
              objectPath.set(
                isUiChanged,
                ['isUpdateFavorite', tableUi.key],
                true,
              )
              setIsUiChanged({ ...isUiChanged })
            } else {
              objectPath.set(
                isUiChanged,
                ['isRenderTable', tableUi.key],
                updatedTable,
              )
              objectPath.set(formData, tableUi.name, updatedTable)
              objectPath.set(formData, tableUi.key, updatedTable)
            }
          }
        }
      } else if (systemType === 'table') {
        let tableUi = getCurrentUi(
          elementKey,
          parentJsonForm.schema,
          parentJsonForm.uischema,
        )
        if (tableUi.key === elementKey) {
          let currentTable = objectPath.get(designerData, propKey) || []
          objectPath.set(formData, tableUi.name, currentTable)
          objectPath.set(formData, tableUi.key, currentTable)
          objectPath.set(
            isUiChanged,
            ['isRenderTable', tableUi.key],
            currentTable,
          )
        }
      } else if (systemType === 'condition') {
        let conditionValue = 1
        objectPath.set(
          formData,
          `@condition.${modalId}.${fullPropKey}`,
          conditionValue,
        )
        if (isPage === 1) {
          objectPath.set(
            newSearchData,
            `@condition.${modalId}.${fullPropKey}`,
            conditionValue,
          )
          objectPath.set(
            formData,
            `@condition.${modalId}.${fullPropKey}`,
            conditionValue,
          )
        }
      }
    })

    setIsOpenModal(false)
    onCheckCondition(parentDesignContext, formData, null, {
      isCloseModal: true,
      modalId,
    })
    objectPath.set(parentJsonForm, 'formData', formData)
    objectPath.set(parentJsonForm, 'designerPropsData.modal', null)
    setJsonForm(parentJsonForm)
    setIsUiChanged(isUiChanged)
    parentJsonFormRef.current = null
    parentFormDataRef.current = null
    parentSearchDataRef.current = null
  }

  useEffect(async () => {
    if (!isOpenModal) return
    let design = {}
    if (!modalCode) return setModal({})
    if (!parentJsonFormRef.current) {
      parentJsonFormRef.current = cloneDeep(jsonForm)
      parentFormDataRef.current = cloneDeep(
        objectPath.get(jsonForm, 'formData') || {},
      )
      parentSearchDataRef.current = cloneDeep(searchData || {})
    }
    if (sourceType === 'form') {
      design = await getForm(modalCode)
    } else if (sourceType === 'page') {
      design = await getPage(modalCode)
    }
    let designJsonForm = design.jsonForm
    if (designJsonForm) {
      objectPath.set(designJsonForm, 'componentPropsData', {})
      let modalMapFormData =
        objectPath.get(designJsonForm, 'schema.mapFormData') || {}
      let modalMapName = objectPath.get(designJsonForm, 'schema.mapName') || {}
      let modalMapField =
        objectPath.get(designJsonForm, 'schema.mapField') || {}
      let modalMapTag = objectPath.get(designJsonForm, 'schema.mapTag') || {}
      let filterModalFormData = Object.keys(modalMapFormData).filter(
        (key) => modalMapFormData[key],
      )
      let schema = jsonForm.schema
      objectPath.set(schema, 'mapModal', {})
      filterModalFormData.forEach((key) => {
        let name = modalMapName[key].split('.').pop()
        objectPath.set(schema, `mapModal.name.${key}`, `modal.${name}`)
        objectPath.set(schema, `mapModal.field.${key}`, modalMapField[key])
        objectPath.set(schema, `mapModal.tag.${key}`, modalMapTag[key])
      })
      setSchema(schema)

      let modal = cloneDeep(ui)
      objectPath.set(modal, 'ui.close', false)
      objectPath.set(modal, 'ui.formDesign', design.formDesign)

      let designerProps = objectPath.get(designerPropsData, 'props') || []
      let receiveProps = objectPath.get(modalAction, 'props') || []
      let designerData = objectPath.get(designerPropsData, 'data')
      let allFormGroup = jsonForm.formGroup
      receiveProps =
        typeof receiveProps === 'object'
          ? Object.values(receiveProps)
          : receiveProps

      let systemData = {}
      receiveProps.map(async (item) => {
        if (!item.propReceive) return
        let value
        let systemKey = item?.systemKey || ''
        let foundDesignerProp = designerProps.find(
          ({ key }) => systemKey === key,
        )
        if (foundDesignerProp) {
          item.system = foundDesignerProp.system
        }
        if (item.systemType === 'tab') {
          let [containerKey, paramName] = systemKey.split('.')
          value = checkPropTab({ designContext }, { containerKey, paramName })
          objectPath.set(systemData, item.fullPropKey, value)
        } else if (item.systemType === 'datasource') {
          value = objectPath.get(datasourceValue, systemKey)
        } else if (item.systemType === 'formData') {
          let form = allFormGroup.find(({ key }) => key === systemKey)
          value = setRequestFormData(
            form,
            {},
            {
              datasourceValue,
              formData: jsonForm.formData,
              allParams,
              jsonForm,
            },
          )
        } else if (item.systemType === 'table') {
          value = objectPath.get(
            designerData,
            `${systemKey}.${item.fullPropKey}`,
          )
          objectPath.set(isUiChanged, '@rowEdit', value)
          if (item.selectedRow) {
            objectPath.set(isUiChanged, ['selectedRow', item.propKey], value)
          }
        } else if (item.systemType === 'replaceRow') {
        } else if (item.systemType === 'condition') {
          value = 1
        } else if (item.propType === 'system') {
        } else if (item.systemType === 'custom') {
          value = item.systemValue
        } else if (item.systemType === 'tableResponse') {
          let tableKey = item.systemKey
          let tableUi = getCurrentUi(
            tableKey,
            jsonForm.schema,
            jsonForm.uischema,
          )
          if (tableUi?.loadData?.method === 'GET') {
            let action = tableUi?.loadData?.get
            let dataKey = action.data
            let requestUrl = getApi(
              action,
              {
                designContext,
              },
              'Modal',
            )
            let response = await httpClient
              .get(requestUrl)
              .then(({ data }) => data)
              .catch(() => [])
            value = dataKey ? objectPath.get(response, dataKey) : response
          } else {
            value = objectPath.get(jsonForm.formData, item.systemKey)
          }
        } else if (item.propReceive && item.systemType === 'input') {
          let ui = getCurrentUi(
            item.systemKey,
            jsonForm.schema,
            jsonForm.uischema,
          )
          if (item.systemKey === ui.key) {
            value =
              objectPath.get(jsonForm.formData, item.systemKey) ||
              objectPath.get(jsonForm.formData, ui.name)
          } else {
            value = objectPath.get(jsonForm.formData, item.systemKey)
          }
        } else if (item.systemType === 'apiResponse') {
          value = objectPath.get(
            jsonForm.formData,
            `@response.${item.systemKey}`,
          )
        } else if (item.systemType === 'tableWaitUpsert') {
          let isWaitUpsert = objectPath.get(isUiChanged, 'isWaitUpsert')
          value = isWaitUpsert?.rowData
        } else if (item.systemType === 'tableConfirmUpsert') {
          let isWaitUpsert = objectPath.get(isUiChanged, 'isWaitUpsert')
          value = isWaitUpsert?.table
        } else {
          value =
            objectPath.get(designerData, item.fullPropKey) ||
            objectPath.get(jsonForm.formData, item.fullPropKey)
        }
        if (
          item.propType === 'datasource' ||
          item.systemType === 'datasource'
        ) {
          objectPath.set(
            datasourceValue,
            `receiveProps.${item.fullPropKey}`,
            value,
          )
        }
        objectPath.set(systemData, item.fullPropKey, value)
        return item
      })

      objectPath.set(designJsonForm, 'designerPropsData.modal', modalCode)

      objectPath.set(designJsonForm, 'designerPropsData.receive', receiveProps)
      objectPath.set(designJsonForm, 'designerPropsData.data', systemData)

      objectPath.set(modal, 'ui.systemData', systemData)
      objectPath.set(modal, 'ui.jsonForm', designJsonForm)
      objectPath.set(modal, 'ui.receiveProps', receiveProps)
      objectPath.set(modal, 'ui.datasourceValue', datasourceValue)
      setModal(modal)
      setIsUiChanged(isUiChanged)
      console.log('modal designer', {
        isUiChanged,
        receiveProps,
        systemData,
        data: designJsonForm.designerPropsData.data,
        modal: designJsonForm.designerPropsData.modal,
        isOpenModal,
        openModal,
        modalCode,
        ui,
        modalAction,
        formData: jsonForm.formData,
        datasourceValue: datasourceValue,
        jsonForm: jsonForm,
        designerPropsData: designerPropsData,
      })

      if (ui.ui) {
        objectPath.del(ui, 'ui')
      }
    } else {
      setModal({})
    }
  }, [isOpenModal])

  if (!modalCode) return <></>

  if (modalSize === 'fullscreen') {
    return (
      <FullSizeModal
        {...props}
        isOpenModal={isOpenModal}
        closeExternalModal={closeExternalModal}
      >
        <Component
          uischema={modal}
          action={modalAction}
          isOpenModal={isOpenModal}
          modalCode={modalCode}
          closeExternalModal={closeExternalModal}
          onRefreshTable={onRefreshTable}
        />
      </FullSizeModal>
    )
  }

  return (
    <NormalModal
      {...props}
      isOpenModal={isOpenModal}
      closeExternalModal={closeExternalModal}
    >
      <Component
        uischema={modal}
        action={modalAction}
        isOpenModal={isOpenModal}
        modalCode={modalCode}
        modalId={modalId}
        closeExternalModal={closeExternalModal}
        onRefreshTable={onRefreshTable}
      />
    </NormalModal>
  )
}

export default ModalTable
